const transformSizePropToSize = (size?: string | number) => {
  if (!size) {
    return;
  } else if (typeof size === 'number') {
    return `${size}px`;
  } else if (size.slice(-2) === 'px') {
    return size;
  } else {
    return `${size}px`;
  }
};

const getBackgroundColor = (isEmpty?: boolean, isFocused?: boolean) => {
  if (isEmpty && !isFocused) {
    return 'var(--background-secondary)';
  } else {
    return 'var(--background-boxes-modals)';
  }
};

export {transformSizePropToSize, getBackgroundColor};
